import "./Orders.scss";
import { useDispatch, useSelector } from "react-redux";
import SingleOrderDetails from "./SingleOrderDetails";
import SingleOrderDetailsExpanded from "./SingleOrderDetailsExpanded";
import { ucp_visualization_presentation } from "../CesiumUtils/Visualizations";
import * as ucpActions from "../../../../store/UnifiedControlPlaneSlice";
import { truncateName } from "../../../../utils/commonFunctions";
import { BreadcrumbArrow, EmptyListIcon } from "../../assets/icons/Icons";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";

const SingleOrderView = ({ props, ucpViewer }) => {
  const dispatch = useDispatch();
  const selectedOrderData = useSelector(
    (state) => state.unifiedControlPlane.selectedOrderData
  );
  const singleOrderAssignments = useSelector(
    (state) => state.unifiedControlPlane.singleOrderAssignments
  );
  const fetchingOAForSingleOrder = useSelector(
    (state) => state.unifiedControlPlane.fetchingOAForSingleOrder
  );

  const showAllOrders = () => {
    ucp_visualization_presentation().remove_highlight_strip(
      ucpViewer,
      "Highlight_Order_Assignment"
    );
    ucp_visualization_presentation().remove_highlight_strip(
      ucpViewer,
      "Highlight_Completed_Order_Assignment"
    );
    dispatch(ucpActions.resetHighlightedOrderAssign());
    dispatch(ucpActions.resetOrderAssignmentsForSingleOrder());
    dispatch(ucpActions.resetSelectedOrderData());
    dispatch(ucpActions.setSingleOrderView(false));
  };

  const getStripsOfCompletedOrderAssignments = (order) => {
    const listOfCompletedStrips = [];
    order.forEach((assignment, index) => {
      if (
        assignment.state === "CaptureComplete" ||
        assignment.state === "DownlinkComplete"
      ) {
        listOfCompletedStrips.push({
          name: index,
          areaOfInterestId: index,
          polygon: assignment.data.strip.geoJSON.coordinates,
        });
      }
    });
    return listOfCompletedStrips;
  };

  useEffect(() => {
    if (singleOrderAssignments && singleOrderAssignments.length > 0) {
      ucp_visualization_presentation().highlightCompletedAssignment(
        ucpViewer,
        "Highlight_Completed_Order_Assignment",
        getStripsOfCompletedOrderAssignments(singleOrderAssignments)
      );
    }
  }, [singleOrderAssignments]);

  return (
    <div
      className={
        props.isExpandedOrdersBar ? "ordersBar expandedOrdersBar singleOrdersBar" : "ordersBar singleOrdersBar"
      }
    >
      <div className="ordersGreenHeaderBar singleOrderView">
        <button
          className="ordersGreenHeader ordersButton"
          onClick={() => showAllOrders()}
        >
          Orders
        </button>
        <span className="breadcrumbArrow">
          <BreadcrumbArrow />
        </span>
        <button className="ordersGreenHeader subOrderHeaderClass activeHeader">
          {selectedOrderData.status.state} Orders
        </button>
      </div>

      <div
        className="ordersTypeHeaderBar"
        style={{ height: "auto", padding: "12px 12px 0px" }}
      >
        <div className="ordersTypeHeaderTwoLineDiv">
          <div
            className="ordersTypeHeader mouse-cursor-normal"
            title={selectedOrderData.spec.name}
          >
            {truncateName(selectedOrderData.spec.name)}
          </div>
          <div className="ordersTypeHeader activeHeader mouse-cursor-normal">
            ASSIGNMENTS
          </div>
        </div>
        {/* need to change the icon of this to expand and commenting this for now we can enable when necessary */}
        {/* <button className="orderThreeDotMenu">
          <img onClick={() => props.setIsExpandedOrdersBar(!props.isExpandedOrdersBar)} src={require("../../assets/raw/ThreeDotIcon.svg").default} alt="" />
        </button> */}
        {/* <div className="orderThreeDotMenu circularBar">
          <CircularProgressBarComponent item={selectedOrderData} />
        </div> */}
      </div>
      {fetchingOAForSingleOrder ? (
        <div className="scheduleDescription loading-spinner">
          <CircularProgress color="inherit" />
        </div>
      ) : singleOrderAssignments && singleOrderAssignments.length > 0 ? (
        <div className="scrollableOrdersBar">
          {!props.isExpandedOrdersBar ? (
            <SingleOrderDetails
              orderAssignments={singleOrderAssignments}
              ucpViewer={ucpViewer}
            />
          ) : (
            <SingleOrderDetailsExpanded
              displayAssingments={singleOrderAssignments}
            />
          )}
        </div>
      ) : (
        <div className="scheduleDescription">
          <EmptyListIcon />
          <div className="scheduleDescription-text-box">
            <span className="scheduleDescription-text">
              No Order Assignments Yet
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleOrderView;
